import styled from '@emotion/styled';
import {css} from '@emotion/react';
import {TextDefault, TextSmall} from '../../../../shared/styles';
import {ReactComponent as PlaceholderSVG} from '../../../../assets/icons/ic_article_placeholder.svg';
import {Link} from 'react-router-dom';

export const CardArticleWrapper = styled(Link)`
  display: flex;
  flex-direction: column;
  text-decoration: none;
`;

// TOP
export const CardArticleTop = styled.div`
  height: 152px;
  border-radius: ${({theme}) =>
    `${theme.border.radius.sm} ${theme.border.radius.sm} 0 0`};
  background-color: ${({theme}) => theme.color.secondary_10};
`;

export const IconPlaceholderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 152px;
`;

export const IconPlaceholder = styled(PlaceholderSVG)`
  width: 75px;
  height: 64px;
  fill: ${({theme}) => theme.color.secondary};
`;

export const ThumbnailImg = styled.img`
  width: 100%;
  height: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  border-radius: ${({theme}) =>
    `${theme.border.radius.sm} ${theme.border.radius.sm} 0 0`};
`;

// BOTTOM
export const CardArticleBottom = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  gap: ${({theme}) => theme.gap.desktop.md};
  padding: ${({theme}) => theme.padding.desktop.md};
  background-color: ${({theme}) => theme.color.neutral.grey_50};
`;

const twoLineEllipsis = css`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const CardArticleTitle = styled(TextDefault)`
  ${twoLineEllipsis};
`;

export const CardArticleDescription = styled(TextSmall)`
  ${twoLineEllipsis};
`;
